module.exports = __webpack_public_path__ + "assets/images/avatar_riscos.1828a379.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/avatar_riscos.png
// module id = 371
// module chunks = 1